<template>
    <v-flex>
        <v-flex v-show="status">
            <div>
                <v-toolbar dark color="gradiente" v-show="!$vuetify.breakpoint.xsOnly">
                    <div >

                    </div>
                </v-toolbar>

            <v-toolbar height="130" v-show="!$vuetify.breakpoint.xsOnly">
                <v-flex xs12 md3 lg3 px-4>
                    <v-list-tile-content>
                            <v-list-tile-title><b>Nombre de la Encuesta </b></v-list-tile-title>
                            <v-list-tile-sub-title>
                                {{ title }}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                </v-flex>
                <v-flex xs12 md3 lg3 px-4>
                    <v-list light style="background-color: transparent;">
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <v-icon >account_circle</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <b>Colaborador</b>
                                <v-list-tile-sub-title>
                                    {{ firstName+" "+lastName}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex xs12 md3 lg3 px-4>
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <v-icon >event</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title><b>Fecha</b></v-list-tile-title>
                            <v-list-tile-sub-title>
                                {{ day }}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-flex>  
            </v-toolbar>

            <v-toolbar height="130" style="background:white" v-show="$vuetify.breakpoint.xsOnly">
                <v-flex xs12 md3 lg3 style="text-align: center;">
                    <p><b>Encuesta:</b>{{" "+ title }}</p>
                    <p><b>Colaborador:</b>{{" "+ firstName+" "+lastName}}</p>
                    <p><b>Fecha</b>:{{" "+ day }}</p>
                </v-flex>
                 
            </v-toolbar>
        </div>

        <v-container id="scrolling-home" class="scroll-y scrollDesign overflow-y-auto contenQues" style="height: 79vh;">
            <div v-for="(question, i) in questions" :key="i" id="question-id" :class="{ 'cardsQuestion2': $vuetify.breakpoint.xsOnly, 'cardsQuestion': !$vuetify.breakpoint.xsOnly }">
                <v-flex xs12 mt-1 >
                    <v-layout row wrap style="justify-content: center;">
                        <v-card  width= "850px" style="border-radius: 15px;">
                            <v-card-title style="background: #EB5860;" class="white--text">
                                <span class="text-h5">{{ question.question }}</span>
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <div v-show="question.type=='TEXT'" style="margin-bottom: 2%;">
                                <div v-if="question.answers[0]">
                                    <v-layout wrap row class="questions-size">
                                        <v-flex xs12 md12 lg12 px-5>
                                            <v-textarea
                                                auto-grow
                                                rows="1"
                                                data-min-rows='1'
                                                v-model="text[i]"
                                                v-on:change="addToAns($event, data = {idPollQuestionAnswer:question.answers[0].id,idPollResult:id,textAnswer:text[i],idQ:question.id}, i )"
                                                placeholder="Escribe una respuesta"
                                                required
                                                maxlength="220"
                                            />
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>
                
                            <div v-show="question.type=='MULTIPLE'" style="margin-bottom: 2%;">
                                <div v-for="(answer, a) in question.answers" :key="a" >
                                    <v-layout wrap row class="questions-size">
                                        <v-flex xs12 md12 lg12 px-5 style="padding-top: 10px;">
                                            <label v-if="answer.answer=='No presenta síntomas'">
                                                <input type="checkbox"
                                                    :value= {idPollQuestionAnswer:answer.id,idPollResult:id,idQ:question.id}
                                                    v-model="multipleAnswer"
                                                    @click="test(answer.id,id,question.id)"
                                                />
                                                <span class="check-box-effect" style="margin-top: 10px;"></span>
                                                <label style="padding-left: 10px; top: -6px; color:#3f3f3f !important">{{ answer.answer }}</label>
                                            </label>
                                            <label v-else>
                                                <input type="checkbox"
                                                    :value= {idPollQuestionAnswer:answer.id,idPollResult:id,idQ:question.id}
                                                    v-model="multipleAnswer"
                                                    :disabled="excludeAnotherAnswers.includes(question.id)"
                                                />
                                                <span class="check-box-effect" style="margin-top: 10px;"></span>
                                                <label 
                                                    style="padding-left: 10px; top: -6px;"
                                                    :style="excludeAnotherAnswers.includes(question.id) ? '' : 'color:#3f3f3f !important'"
                                                >
                                                    {{ answer.answer }}
                                                </label>
                                            </label>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>

                            <div v-show="question.type=='SINGLE'" style="margin-bottom: 2%; margin-top: 2%;">
                                <v-layout wrap row class="questions-size" >
                                    <v-flex xs12 md12 lg12 px-5>
                                        <v-radio-group v-model="answers[i]">
                                            <v-radio
                                                color="#eb5860"
                                                v-for="a in question.answers" 
                                                :key="a.id"
                                                :label="a.answer"
                                                :value="{idPollQuestionAnswer:a.id,idPollResult:id,idQ:question.id}"
                                            />
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                            </div>

                        </v-card>
                    </v-layout>
                </v-flex>
            </div>
            <v-divider style="background: #848484;" v-show="$vuetify.breakpoint.xsOnly "></v-divider>
            <div :class="{ 'checkC1': $vuetify.breakpoint.xsOnly, 'checkC': !$vuetify.breakpoint.xsOnly }">
                <label>
                    <input type="checkbox" 
                        :value= !keycondition 
                        v-model="keycondition"       
                    />
                    <span class="check-box-effect"></span>
                    <label style="padding-left: 10px;">Hago constar que he contestado de manera correcta todas las preguntas.</label>
                </label>
            </div>
            <div :class="{ 'bottonStyle1': $vuetify.breakpoint.xsOnly, 'bottonStyle': !$vuetify.breakpoint.xsOnly }">
                <v-btn
                    style="width: 150Px; justify-content: center;"
                    color="gradiente"
                    class="white--text"
                    @click="pollSummit()"
                >Enviar</v-btn>
            </div>
            <div style="height:50px" v-show="$vuetify.breakpoint.xsOnly"></div>
        </v-container>

        </v-flex>
        <div data-app>
            <alerta 
                v-model="modals.alert" 
                :text="modals.Clave" 
                :title="modals.Title" 
                :cond="modals.Cond" 
                @cancelled="onCancel"
            ></alerta>
        </div>
    </v-flex>
</template>


<script>
import alerta from "./PollAlert.vue"
export default {
    components:{
        alerta, 
    },
    data () {
        return {
            excludeAnotherAnswers: [],
            questions: [],
            questions1: [],
            modals: {
                alert: false,
                Clave: "",
                Title: "",
                Cond: false,
            },
            id: "",
            a:0,
            status: false,
            firstName: "",
            lastName: "",
            title: "",
            day: "",
            options: { year:'numeric', month:'numeric', day:'numeric', },
            answers: [],
            ans:[],
            multipleAnswer: [],
            simpleAnswer: [],
            text: [],
            pollCol: {},
            keycondition:false,
            complete:false,
        }
    },
  methods: {
    test(Aid,id,Qid){
        console.log(id)
        if (this.excludeAnotherAnswers.includes(Qid)) {
            this.excludeAnotherAnswers = this.excludeAnotherAnswers.filter(i => i != Qid);
        } else {
            this.excludeAnotherAnswers = [Qid];
        }
        
        this.multipleAnswer = this.multipleAnswer.filter((item)=>item.idPollQuestionAnswer == Qid);

        this.multipleAnswer.push({idPollQuestionAnswer:Aid,idPollResult:id,idQ:Qid})
    },
    getPollC(id){
        this.$store
            .dispatch("polls/getCPoll",id)
            .then((response) => {
                var cond = response.data.available;
                if (cond==true) {
                    this.status = true;
                    this.firstName = response.data.collaborator.firstName;
                    this.lastName = response.data.collaborator.lastName;
                    this.id = response.data.pollResultId;
                    this.title = response.data.title;
                    var date = new Date(response.data.createdAt)
                    this.day = date.toLocaleDateString('en-GB', this.options)
                    this.questions = response.data.questions;
                    this.questions1 = response.data.questions;
                }else{
                    this.status = false;
                    this.modals.Clave = "Esta encuesta ya ha sido contestada anteriormente, asegúrate de elegir las encuestas pendientes por contestar."
                    this.modals.alert = true;
                    this.modals.Cond = false;
                }
            })
            .catch((error) => {
                this.status = false
                this.modals.Title = "¡Encuesta No Disponible!"
                this.modals.Clave = "Esta encuesta ya no se encuentra disponible."
                this.modals.Cond = false;
                this.modals.alert = true;
                console.log(error)
            });
    },
    pollSummit(){
        this.ans = [];
        for (let index = 0; index < this.answers.length; index++) {
            this.ans.push(this.answers[index])
        }
        for (let index = 0; index < this.multipleAnswer.length; index++) {
            this.ans.push(this.multipleAnswer[index])
        }

        for (let index = 0; index < this.ans.length; index++) {
            if (this.ans[index] == null) {
                this.ans.splice(index,1) 
            }
        }
        this.pollCol.id =  this.id;
        this.pollCol.answers = this.ans;
        var rs = 0;

        for (let index = 0; index < this.questions1.length; index++) {
            for (let index1 = 0; index1 < this.ans.length; index1++) {
                if (this.ans[index1] != null) {
                    if (this.questions1[index].id == this.ans[index1].idQ) {
                        rs++;
                        index1 = this.ans.length;
                    }
                }
                  
            }
        }

        if (this.questions1.length == rs) {
            if (this.keycondition == true) {
                for (let index = 0; index < this.pollCol.answers.length; index++) {
                    if (this.pollCol.answers[index] == null) {
                        this.pollCol.answers.splice(index,1)
                        index--; 
                    }
                }
                this.$store
                .dispatch("polls/postColPoll",this.pollCol)
                .then(() => {
                    this.modals.Title = "¡Encuesta realizada con éxito!"
                    this.modals.Clave = "Tus respuestas han sido enviadas con éxito, serán revisadas por un miembro correspondiente de la institución."
                    this.modals.Cond = false;
                    this.modals.alert = true;
                })
                .catch(() => {
                    this.modals.Title = "Problema al enviar respuestas"
                    this.modals.Clave = "Las respuestas no se pudieron enviar, ya que la encuesta no se encuentra disponible o ha sido eliminado por el colegio."
                    this.modals.Cond = true;
                    this.modals.alert = true;
                });
            } else {
                this.modals.Clave = "Asegúrate de habilitar la casilla de constancia de respuestas correctas."
                this.modals.alert = true;
                this.modals.Cond = true;
            } 
        } else {
            this.modals.Clave = "Asegúrate de contestar todas las preguntas que se muestran en el formulario antes de enviar"
            this.modals.alert = true;
            this.modals.Cond = true;
        }
        rs = 0;
    },

    addToAns: function (event, data, index) {
        if (data.textAnswer != "") {
            this.answers.splice(index, 1, data);
        } else {
            this.answers[index].idQ = 0
        }
        
    },

	onCancel() {
		this.modals.alert = false;
		this.$forceUpdate();
	},

  },
  mounted() {
    this.getPollC(this.$route.params.id);
  },


}
</script>

<style>
.cardsQuestion {
    margin-top: 2%; 
    margin-bottom: 1%; 
    justify-content: center;
}
.cardsQuestion2 {
    margin-bottom: 5%;
    justify-content: center; 
}


.checkC{
    text-align: center;
}
.checkC1{
    text-align: center;
    margin-bottom: 4%;
}
.checkboxAns{
    border-radius: 50%;
    cursor: pointer;
    height: 20px;
    width: 20px;
    margin: 8px;
}

.bottonStyle{
    margin-top: 2%;
    margin-bottom: 3%;
    text-align: center;
}
.bottonStyle1{
    text-align: center;
    margin-top: 5%;
}

label {
  color: #7e7e7e;
  cursor: pointer;
  position: relative;
}

label .check-box-effect {
  display: inline-block;
  position: relative;
  background-color: transparent;
  width: 25px;
  height: 25px;
  border: 2px solid #dcdcdc;
  border-radius: 10%;
}

label .check-box-effect:before {
  content: "";
  width: 0px;
  height: 2px;
  border-radius: 2px;
  background: #626262;
  position: absolute;
  transform: rotate(45deg);
  top: 11px;
  left: 6px;
  transition: width 50ms ease 50ms;
  transform-origin: 0% 0%;
}

label .check-box-effect:after {
  content: "";
  width: 0;
  height: 2px;
  border-radius: 2px;
  background: #626262;
  position: absolute;
  transform: rotate(305deg);
  top: 15px;
  left: 8px;
  transition: width 50ms ease;
  transform-origin: 0% 0%;
}

label:hover .check-box-effect:before {
  width: 5px;
  transition: width 100ms ease;
}

label:hover .check-box-effect:after {
  width: 10px;
  transition: width 150ms ease 100ms;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]:checked + .check-box-effect {
  background-color: #eb5860 !important;
  transform: scale(1.25);
}

input[type="checkbox"]:checked + .check-box-effect:after {
  width: 10px;
  background: rgb(255, 255, 255);
  transition: width 150ms ease 100ms;
}

input[type="checkbox"]:checked + .check-box-effect:before {
  width: 5px;
  background: rgb(255, 255, 255);
  transition: width 150ms ease 100ms;
}

input[type="checkbox"]:checked:hover + .check-box-effect {
  background-color: #dcdcdc;
  transform: scale(1.25);
}

input[type="checkbox"]:checked:hover + .check-box-effect:after {
  width: 10px;
  background: #333;
  transition: width 150ms ease 100ms;
}

input[type="checkbox"]:checked:hover + .check-box-effect:before {
  width: 5px;
  background: #333;
  transition: width 150ms ease 100ms;
}
</style>